(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name deadHeadingReport.controller:DeadHeadingReportCtrl
   *
   * @description
   *
   */
  angular
    .module('deadHeadingReport')
    .controller('DeadHeadingReportCtrl', DeadHeadingReportCtrl);

  function DeadHeadingReportCtrl(crewScheduleService, CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'DeadHeadingReportCtrl';

		vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				origin : null,
				destination : null,
				crewType : null,
				crewName : null
			},
			masterList : {
				airportList : [],
				crewTypeList : [],
				crewNameList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchDeadHeadingReport(params);
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
			if (flag === 'crewType') {
				vm.model.masterList.crewNameList = loadCrewList(searchParams.crewType);
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
		}
		;

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search Dead Heading Report
		function searchDeadHeadingReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						"dead_heading.rptdesign",
						getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
      if (!!param.origin && !!param.origin.airPortCode) {
        searchParamMap["fromAirport"] = param.origin.airPortCode;
      }
      if (!!param.destination && !!param.destination.airPortCode) {
        searchParamMap["toAirport"] = param.destination.airPortCode;
      }
			if (!!param.crewType && !!param.crewType.crewTypeCode) {
				searchParamMap["crewType"] = param.crewType.crewTypeCode;
			}
			if (!!param.crewName && !!param.crewName.crewId) {
				searchParamMap["crewName"] = param.crewName.crewId;
			}
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			if (!!vm.model.searchCriteria.fromDate
					&& !vm.model.masterList.fromDateFormatInvalid
					&& !!vm.model.searchCriteria.toDate
					&& !vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateAfterToDate
					) {
				return true;
			}
			return false;
		}

		// load crew list
		function loadCrewList(crewType) {
			var param = {};
			param.crewType = '';
			param.active = true;
			if (!!crewType) {
				param.crewType = crewType.crewTypeCode;
				CommonMasterData.loadCrewList(param, function(response) {
					vm.model.masterList.crewNameList = crewScheduleService
							.adaptCrewList(response);
					vm.model.searchCriteria.crewName = null;
				}, function() {
					console.log('Crew list retrieval error');
				});
			} else {
				vm.model.masterList.crewNameList = [];
				vm.model.searchCriteria.crewName = null;
			}
		}
		;
		(function() {
			// load airport list
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function(error) {
				console.log('Airport List retrieval error!!!');
			});
			// crew type codes
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
        var initialCrew = {crewTypeCode: null, crewTypeDescription: "All", crewTypeMasterCode: null, crewTypeMasterCodeDesc: null, rank: 0};
        vm.model.masterList.crewTypeList = crewTypeList;
        vm.model.masterList.crewTypeList.splice(0, 0, initialCrew);
			}, function() {
				console.log('Crew Type list retrieval error');
			});

		})();
	}
}());
